/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { createContext, useEffect, useState } from "react";
import { api } from "../../services/api";

let ccid = localStorage.getItem("CoastCenterID");
const urlCCID = new URL(window.location);
const decodedStr = atob(urlCCID.searchParams.get("ccid"));

if (ccid == undefined || ccid == null || ccid != decodedStr) {
    if (ccid !== decodedStr && decodedStr !== atob(null)) {
        localStorage.setItem("CoastCenterID", decodedStr);
    } else {
        localStorage.setItem("CoastCenterID", ccid);
    }
}

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) =>{
    const [user, setUser] = useState();
    const [login, setLogin] = useState(undefined);
    const [matricula1, setMatricula1] = useState();
    const [passenger, setPassenger] = useState();
    const [ccLogin, setCCLogin] = useState();
    
    let ccid1 = localStorage.getItem("CoastCenterID");
    
    // Para verificar se o CC necessita de login
    const CC = async () => {
        try {
            const response = await api.get(`/busline?cost_center_id=${ccid1}`);
            const costCenter = response.data.map((m)=>{
                return m.cost_center
            })
            const costCenterFilter = costCenter.filter(function (a) {
                const key = JSON.stringify(a);
                if (!this[key]) {
                    this[key] = true; // Set the property to true for uniqueness check
                    return true; // Include the element in the filtered result
                }
                return false; // Exclude the element from the filtered result
            }, Object.create(null));
            setCCLogin(costCenterFilter)
        } catch (error) {
            console.log('error', error)
            alert('Não existem linhas para esse centro de custo.');
        }
    };

    useEffect(()=>{
        CC();
    },[])

    useEffect(() => {
        if (!ccLogin) return

        // /login?ccid=MjYw  - 260
        // /?ccid=MjYw  - 260
        // /login?ccid=Mjcx  - 271
        // /?ccid=Mjcx  - 271
        // /login?ccid=MjYwLDI3MQ==  - 260,271
        // /?ccid=MjYwLDI3MQ==  - 260,271

        // Verifique se há pelo menos um centro de custo que não requer login
        const notRequiresLogin = ccLogin.some((cc) => cc.login === false);
        // Se algum centro de custo não requer login, defina o tokenSemLogin no localStorage
        const tokenseted = sessionStorage.getItem("token")
        if (tokenseted != null) {
            setLogin(true) 
            return
        }
        if (notRequiresLogin) {
            // Se tiver, insere um token fixo para logar automaticamente
            setLogin(true)
            setUser({matricula:'222'})
            sessionStorage.setItem("botao", false)
            sessionStorage.setItem("token", JSON.stringify({matricula:'222', token:"dce1df6gfwn"}))
        }
        else{
            setLogin(false)
            sessionStorage.setItem("botao", true)
        }
    }, [ccLogin]);


    const signin = (matricula) => {
          setMatricula1(matricula)
        //   console.log('1');
        //   console.log('matricula',matricula);
        //   console.log('matricula1 1',matricula1);
        
    }

    useEffect(()=>{
        // console.log('2');
        if(matricula1){
            // console.log('matricula1 2',matricula1);
            getPassager()
        }

        // console.log('2.1');
        if (sessionStorage.getItem("numero_matricula")) {
            // console.log('sessionStorage.getItem("numero_matricula")',sessionStorage.getItem("numero_matricula"));
            getPassager()
        }
    },[matricula1])

    //Pega as informações
    const getPassager = async () => {
        // console.log('3');
        
        //filtrar os passageiros com a matricula especifica, que está ativo e que o centro de custo seja o mesmo que o da url
        try {
            const res = await api.get(`/passengerapp?matricula=${matricula1? matricula1:sessionStorage.getItem("numero_matricula")}&ccid=${ccid1}`);
            // console.log('res',res);
            const filteredPassengers = res.data.filter(passenger => {
                    return passenger.passenger_id === null;
            });
            // console.log('filteredPassengers',filteredPassengers);
            setPassenger(filteredPassengers);
            localStorage.removeItem("error")
        } catch (error) {
            localStorage.setItem("error", "Passageiro não encontrado")
            console.log(error);
        }
    };

    const checkData = () =>{
        // console.log('4');
        const usersStorage = passenger
        const hasUser = usersStorage?.filter((user) => user.matricula === matricula1)
        
        if(hasUser?.length){
            // console.log('5');
            if(hasUser[0].matricula === matricula1){
                const token = Math.random().toString(36).substring(2);
                sessionStorage.setItem("token", JSON.stringify({matricula1, token}))
                sessionStorage.setItem("numero_matricula", matricula1)
                localStorage.removeItem("error")
                // console.log('6');
                setUser({matricula1})
                return;
            }else{
                localStorage.setItem("error", "Matrícula incorreta")
                return "Matrícula incorreta";
            }
        }else{
            localStorage.setItem("error", "Passageiro não encontrado")
            return "Passageiro não encontrado";
        }
    }

    useEffect(()=>{
        if (!matricula1) return
        // console.log('useefects checkData');
        checkData()
    },[passenger])

    useEffect(()=>{
        // console.log('7');
        if(!passenger) return
        // console.log('7.1');
        const userToken = sessionStorage.getItem("token");
        // console.log('passenger', passenger);
        // console.log('userToken', userToken);
        const usersStorage = passenger
        
        if(userToken && usersStorage){
            console.log('8');
            const hasUser = usersStorage?.filter(
                    (user) => {
                        // console.log('user do filter', user.matricula);
                        // console.log('userToken do filter', JSON.parse(userToken).matricula1);
                        return user.matricula === JSON.parse(userToken).matricula1
                    }
            );
            console.log('hasUser', hasUser);
            if (hasUser[0]){
                // console.log('9');
                setUser(hasUser[0]);
                setLogin(true)
            }

        }
    },[passenger]);
    

    const signout = () => {
        setUser(null);
        setMatricula1(null);
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("numero_matricula");
    }

    return (
        <AuthContext.Provider
            value={login===undefined ? {user, signed: 1, signin, checkData, signout} : login===false ? {user, signed: 2, signin, checkData, signout} : {user, signed: 3, signin, checkData, signout} }
        >
            {children}
        </AuthContext.Provider>
    )
}